import { useRef, useState } from "react";
import axios from "axios";
import { Upload, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";

export function LogoUploader({ prefs, savingPrefs, onChange }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const upload = async (file) => {
    if (!file) return;
    if (!/^image\/(png|jpe?g|webp)$/i.test(file.type)) { setErr("Sadece PNG, JPG veya WebP"); return; }
    if (file.size > 500 * 1024) { setErr("Max 500KB"); return; }
    setBusy(true); setErr("");
    try {
      const fd = new FormData();
      fd.append("file", file, file.name);
      await axios.post(`${API}/user/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      if (onChange) await onChange();
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || "Yükleme başarısız");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const remove = async () => {
    if (!window.confirm("Logoyu kaldırmak istediğinize emin misiniz?")) return;
    setBusy(true); setErr("");
    try {
      await axios.delete(`${API}/user/logo`);
      if (onChange) await onChange();
    } catch (e) {
      setErr(e?.response?.data?.detail || e?.message || "Silinemedi");
    } finally {
      setBusy(false);
    }
  };

  const hasLogo = !!prefs?.logoUrl;
  return (
    <div className="logo-uploader" data-testid="logo-uploader">
      {hasLogo && (
        <div className="logo-preview-box" data-testid="logo-preview-box">
          <img src={prefs.logoUrl} alt="Logo önizleme" data-testid="pref-logo-preview" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        </div>
      )}
      <input
        type="file"
        ref={fileRef}
        accept="image/png,image/jpeg,image/webp"
        style={{ display: "none" }}
        data-testid="logo-file-input"
        onChange={(e) => upload(e.target.files?.[0])}
      />
      <div className="logo-actions">
        <button type="button" className="outline-button" onClick={() => fileRef.current?.click()} disabled={busy || savingPrefs} data-testid="logo-upload-button">
          <Upload size={14} /> {busy ? "Yükleniyor…" : (hasLogo ? "Logoyu değiştir" : "Logo yükle")}
        </button>
        {hasLogo && (
          <button type="button" className="text-button" onClick={remove} disabled={busy || savingPrefs} data-testid="logo-remove-button" style={{ color: "#dc2626" }}>
            <Trash2 size={13} /> Kaldır
          </button>
        )}
      </div>
      <em className="field-hint">PNG / JPG / WebP · max 500KB · 220×60px önerilir · tüm e-postaların üstünde gösterilir</em>
      {err && <small style={{ color: "#dc2626", fontSize: 11, display: "block", marginTop: 6 }} data-testid="logo-error">{err}</small>}
    </div>
  );
}
